
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import ConsumerConsumptionChart from '@/components/ConsumerConsumptionChart';

const ConsumptionTrendsCard: React.FC = () => {
  return (
    <Card className="shadow-md border-orange-100 dark:border-orange-900/50 bg-gradient-to-br from-white to-orange-50/30 dark:from-gray-800 dark:to-orange-950/10 overflow-hidden">
      <CardHeader className="pb-1 pt-3">
        <CardTitle className="text-lg font-semibold text-orange-800 dark:text-orange-300">Consumer Usage Trends</CardTitle>
        <CardDescription className="text-orange-600/80 dark:text-orange-400/80 text-xs">Monthly energy consumption by consumer segment</CardDescription>
      </CardHeader>
      <CardContent className="p-3 overflow-hidden">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-3">
          <div className="bg-white/90 dark:bg-gray-800/60 p-2 rounded-lg shadow-sm border border-orange-50 dark:border-orange-900/30 h-52 overflow-hidden">
            <h3 className="text-xs font-medium mb-1 text-orange-700 dark:text-orange-300">Residential</h3>
            <div className="h-[calc(100%-1.25rem)] overflow-hidden">
              <ConsumerConsumptionChart userId="energy-residential" className="h-full" />
            </div>
          </div>
          <div className="bg-white/90 dark:bg-gray-800/60 p-2 rounded-lg shadow-sm border border-orange-50 dark:border-orange-900/30 h-52 overflow-hidden">
            <h3 className="text-xs font-medium mb-1 text-orange-700 dark:text-orange-300">Commercial</h3>
            <div className="h-[calc(100%-1.25rem)] overflow-hidden">
              <ConsumerConsumptionChart userId="energy-commercial" className="h-full" />
            </div>
          </div>
          <div className="bg-white/90 dark:bg-gray-800/60 p-2 rounded-lg shadow-sm border border-orange-50 dark:border-orange-900/30 h-52 overflow-hidden">
            <h3 className="text-xs font-medium mb-1 text-orange-700 dark:text-orange-300">Industrial</h3>
            <div className="h-[calc(100%-1.25rem)] overflow-hidden">
              <ConsumerConsumptionChart userId="energy-industrial" className="h-full" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ConsumptionTrendsCard;
